export class SxSubscription {
    subscriptionCode: string;
    organizationCode: string;
    descripcion: string;
    descripcionExt?: string;
    imagen?: string;
    negocios?: any[];
    preset?: string;
    url?: string;
    username?: string;
    password?: string;
    creado?: string;
    modificado?: string;
    fechaCreacion?: Date;
    fechaActualizacion?: Date;
    completitud?: any;
    urlImage?: string;
    roleUpdate? : any;
};


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/classes/subscription.class.ts